/** 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 * Temporary controls may disappear while their modal is open. Their owner
 * supplies a persistent return target without retaining detached DOM nodes.
 */
const returnTargets = new WeakMap<HTMLElement, HTMLElement>();

export function registerModalFocusReturnTarget(surface: HTMLElement, target: HTMLElement): () => void {
    returnTargets.set(surface, target);
    return () => { returnTargets.delete(surface); };
}

export function getModalFocusReturnTarget(opener: HTMLElement): HTMLElement | null {
    for (let node: HTMLElement | null = opener; node; node = node.parentElement) {
        const target = returnTargets.get(node);
        if (target) return target;
    }
    return null;
}
